import { __read } from 'tslib';
import { useEffect, useCallback } from 'react';
import { useMachine } from '@xstate/react';
import { dropdownMachine } from './dropdownMachine.js';

var useDropdownMachine = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a;
    var _b = __read(useMachine(dropdownMachine), 2), state = _b[0], sendEvent = _b[1];
    useEffect(function () {
        if (disabled) {
            sendEvent("DISABLE");
        }
        else if (state.matches("disabled")) {
            sendEvent("ENABLE");
        }
    }, [disabled]);
    var isOpen = state.matches("open");
    var keyDownHandler = useCallback(function (event) {
        return sendEvent({ type: "keyDown".concat(event.key) });
    }, [sendEvent]);
    var setIsOpen = useCallback(function (open) {
        return sendEvent({ type: open ? "OPEN" : "CLOSE" });
    }, [sendEvent]);
    var toggleIsOpen = useCallback(function () { return sendEvent({ type: "TOGGLE" }); }, [sendEvent]);
    return {
        state: state,
        send: sendEvent,
        isOpen: isOpen,
        keyDownHandler: keyDownHandler,
        setIsOpen: setIsOpen,
        toggleIsOpen: toggleIsOpen,
    };
};

export { useDropdownMachine };
//# sourceMappingURL=useDropdownMachine.js.map
